var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-custom-select-option',{attrs:{"scope":_vm.scope}},[_c('q-item-section',[_vm._v(" "+_vm._s(_vm.bankName)+" ")]),_c('q-item-section',{attrs:{"side":""}},[_vm._v(" ("+_vm._s(_vm.bankNumber)+") ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }